import React from 'react';
import "./pageNews.css"

function PageNews() {
    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
    });

    return (
        <div className="d-flex row m-0 justify-content-center">
            <div className="content-container col-lg-8 ">
                <p className="text-muted TextAboutUs mt-5">22, January/2025</p>
                <h2 className="TextAboutUs">New Site Creation</h2>

            </div>
            
        </div>
        
    );
}

export default PageNews;
